import { render, staticRenderFns } from "./common_switch.vue?vue&type=template&id=e7c023f2&"
import script from "./common_switch.vue?vue&type=script&lang=js&"
export * from "./common_switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports